import ColorWrapper from "Components/ColorWrapper";
import { StyledInput } from "Components/Form/Card/styled";
import { InsuranceCoverage } from "Store/interfaces/products/coverage";
import { radioTrackId } from "Utils/analytics";
import { Field, FieldProps, useFormikContext } from "formik";
import React from "react";
import { ChildPriceFormValues } from "../../childProductPriceInterfaces";
import { Chip } from "./Chip";
import {
  CoverageCardHeader,
  HeaderWrapper,
} from "./selectableChildCoveragePayment.styled";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  value: InsuranceCoverage;
  label: string;
  labelDetails?: React.ReactNode;
  chipText?: string;
}

export const SelectableChildCoveragePayment = ({
  id,
  value,
  label,
  labelDetails,
  checked,
  children,
  chipText,
  ...rest
}: Props): React.ReactElement => {
  const formProps = useFormikContext<ChildPriceFormValues>();
  const inputRef = React.useRef<HTMLInputElement>(null);
  const inputId = radioTrackId(id);

  return (
    <div style={{ marginBottom: "16px" }}>
      <Field name={id} value={value} type="radio">
        {({ field }: FieldProps) => (
          <ColorWrapper borderRadius="16px">
            <CoverageCardHeader onClick={() => inputRef.current?.click()}>
              <HeaderWrapper>
                <StyledInput
                  {...field}
                  {...rest}
                  checked={checked}
                  value={value}
                  type="radio"
                  ref={inputRef}
                  id={inputId}
                  data-trackid={inputId}
                  onClick={(e) => {
                    e.stopPropagation();
                    formProps.setFieldValue("coverage", value);
                  }}
                />
                <label
                  style={{
                    alignItems: "center",
                    display: "flex",
                    flexFlow: "row nowrap",
                  }}
                  htmlFor={inputId}
                >
                  {label}
                  {<Chip chipText={chipText} />}
                </label>
              </HeaderWrapper>
              {labelDetails}
            </CoverageCardHeader>
            <div style={{ marginLeft: "20px" }}>{children}</div>
          </ColorWrapper>
        )}
      </Field>
    </div>
  );
};
